import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import { GetRecommendedQuizzes } from '../types';

export const getRecommendedQuizzes =
  (): Promise<GetRecommendedQuizzes.Root> => {
    return axios.get('/assessment/v1/users/reports/get-recommended-quizzes');
  };

export const getRecommendedQuizzesMockHandler = http.get(
  `${env.API_URL}/assessment/v1/users/reports/get-recommended-quizzes`,
  async (): Promise<HttpResponse<GetRecommendedQuizzes.Root>> => {
    await networkDelay();

    const mockResponse: GetRecommendedQuizzes.Root = {
      status: 'success',
      responseBody: [
        {
          preDefinedRoomId: 'YSVOZR',
          roomName: '01.1.5: Place value',
          roomType: 'PRE-DEFINED-USER-QUIZ',
          numberOfQuestions: 15,
          duration: 20,
          banner: 'https://picsum.photos/200',
          moduleId: '264d6f00-ad1f-4c0e-9979-c391df883631',
          attemptStatus: false,
          reattemptAllowed: true,
          lastMarksObtained: 10,
          lastCoinsEarned: 10,
        },
        {
          preDefinedRoomId: 'VCBJUU',
          roomName: '01.1.3: Expanded Form',
          roomType: 'PRE-DEFINED-USER-QUIZ',
          numberOfQuestions: 15,
          duration: 20,
          banner: 'https://picsum.photos/200',
          moduleId: '264d6f00-ad1f-4c0e-9979-c391df883631',
          attemptStatus: false,
          reattemptAllowed: true,
          lastMarksObtained: 20,
          lastCoinsEarned: 0,
        },
        {
          preDefinedRoomId: 'GXJYY5',
          roomName: '01.3.7: Distributive Property (1D * 1D)',
          roomType: 'PRE-DEFINED-USER-QUIZ',
          numberOfQuestions: 15,
          duration: 20,
          banner: 'https://picsum.photos/200',
          moduleId: '9a0dff51-e972-4491-9072-4310bcda09a3',
          attemptStatus: false,
          reattemptAllowed: true,
          lastMarksObtained: 30,
          lastCoinsEarned: 10,
        },
        {
          preDefinedRoomId: '3VJSAT',
          roomName: '01.3.8: Multiplication (1D * 1D)',
          roomType: 'PRE-DEFINED-USER-QUIZ',
          numberOfQuestions: 15,
          duration: 15,
          banner: 'https://picsum.photos/200',
          moduleId: '9a0dff51-e972-4491-9072-4310bcda09a3',
          attemptStatus: false,
          reattemptAllowed: true,
          lastMarksObtained: 40,
          lastCoinsEarned: 10,
        },
        {
          preDefinedRoomId: 'RL5SIY',
          roomName: '01.2.5: LR Addition (VB)',
          roomType: 'PRE-DEFINED-USER-QUIZ',
          numberOfQuestions: 15,
          duration: 20,
          banner: 'https://picsum.photos/200',
          moduleId: '58d86d09-a865-48c4-ac97-52f7fb88416b',
          attemptStatus: false,
          reattemptAllowed: true,
          lastMarksObtained: 10,
          lastCoinsEarned: 10,
        },
      ],
      errorCode: 0,
      errorMessage: null,
    };

    return HttpResponse.json(mockResponse);
  }
);
